function isSceneObject(obj) {
  return obj.useState !== void 0;
}
function isDataRequestEnricher(obj) {
  return "enrichDataRequest" in obj;
}

export { isDataRequestEnricher, isSceneObject };
//# sourceMappingURL=types.js.map
